/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AreaCreateRequest } from '../../models/area-create-request';
import { AreaResponse } from '../../models/area-response';

export interface CreateArea$Params {
      body: AreaCreateRequest
}

export function createArea(http: HttpClient, rootUrl: string, params: CreateArea$Params, context?: HttpContext): Observable<StrictHttpResponse<AreaResponse>> {
  const rb = new RequestBuilder(rootUrl, createArea.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AreaResponse>;
    })
  );
}

createArea.PATH = '/api/v1/areas';
